import { Box, Typography } from '@mui/material';
import React, { ReactElement } from 'react';

export interface LabelPillProps {
  label: string;
  active?: boolean;
}

/**
 * Small outlined pill used beside toggle switches (e.g. "Members Only",
 * "Public", "Yes", "No"). Matches Figma node 4351:6429.
 */
export const LabelPill = ({
  label,
  active = true,
}: LabelPillProps): ReactElement => (
  <Box
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      px: '16px',
      py: '4px',
      border: '1px solid #383838',
      borderRadius: '9999px',
      opacity: active ? 1 : 0.5,
      flexShrink: 0,
    }}
  >
    <Typography
      sx={{
        fontFamily: 'Poppins, sans-serif',
        fontSize: '12px',
        fontWeight: 600,
        lineHeight: '18px',
        color: '#383838',
        letterSpacing: 0,
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </Typography>
  </Box>
);
